import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import { globalLayout } from '@atlassian/jira-global-layout';
import { createEntry } from '@atlassian/jira-route-entry';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { projectNotFoundRoute } from '@atlassian/jira-router-routes-project-not-found-routes';
import { ProjectNotFoundOrNoPermissionErrorPage } from './ui';

export const projectNotFoundRouteEntry = createEntry(projectNotFoundRoute, {
	component: componentWithFG(
		'jsw-jet-yamato-fe-perm-content-and-error-page',
		ProjectNotFoundOrNoPermissionErrorPage,
		ErrorPagesNotFound,
	),
	layout: globalLayout,
	resources: [...getNavigationResources()],
	forPaint: [LazyAtlassianNavigation],
});
